import { memo } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { addPointsInText } from '../../../../helpers/app';
import { PublicationVersionSelectorProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationVersionSelector = ({
  publication,
  selectedVersion,
  setSelectedVersion,
  type,
  vehicleTypeSelected,
  brand
}: PublicationVersionSelectorProps) => {
  // Solo mostrar si es para marcas, vehículos nuevos y no es mi publicación
  if (type === "myPublication" || vehicleTypeSelected !== "new" || !brand) {
    return null;
  }

  const vehicles = publication?.vehicles || [];
  if (vehicles.length === 0) {
    return null;
  }

  const sortedVehicles = [...vehicles].sort((a, b) => (a.price || 0) - (b.price || 0));

  const isScrollable = sortedVehicles.length > 3;

  return (
    <>
      <h3 className={styles.selectorTitle}>Selecciona la versión</h3>
      <div className={styles.versionSelector} style={isScrollable ? { height: '280px', overflowY: 'auto', overflowX: 'hidden' } : {}}>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            name="vehicleVersion"
            value={selectedVersion}
            onChange={(e) => setSelectedVersion?.(e.target.value)}

          >
            {sortedVehicles.map((vehicle: any) => (
              <div
                className={`${styles.versionCardContainer} ${selectedVersion === vehicle._id ? styles.selectedVersion : ''}`}
                key={vehicle._id}
              >
                <FormControlLabel
                  value={vehicle._id}
                  control={<Radio />}
                  className={styles.versionRadio}
                  label={
                    <div className={styles.versionOption}>
                      <div className={styles.versionName}>
                        {vehicle.version || vehicle.name || `${vehicle.year} ${vehicle.model}`}
                      </div>
                      <div className={styles.versionPrice}>
                        ${addPointsInText(vehicle.price)}
                      </div>
                    </div>
                  }
                />
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};

export default memo(PublicationVersionSelector);
